import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t, i18n } = useTranslation();
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  
  // Update the year automatically
  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  // Create a common header component to ensure consistency
  const SectionHeader = ({ titleKey }) => (
    <h3 className="font-mono text-sm font-bold mb-4 flex items-center">
      {t(titleKey)}
      <span className="inline-block w-1.5 h-1.5 bg-emerald-800 ml-1"></span>
    </h3>
  );

  // Updated link component for consistent styling that creates actual links
  const FooterLink = ({ textKey, to }) => {
    const text = t(textKey);
    
    return (
      <Link to={to} className="font-mono text-xs hover:text-emerald-800 transition-colors">
        {text}
      </Link>
    );
  };

  return (
    <footer className="w-full bg-white border-t border-gray-200">
      <div className="container mx-auto px-4 py-12">
        {/* Main footer content area */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-12">
          {/* Contact column */}
          <div className="flex flex-col items-start">
            <SectionHeader titleKey="footer_contact" />
            {/* <p className="font-mono text-xs">{t('footer_address_street')}</p>
            <p className="font-mono text-xs">{t('footer_address_city')}</p> */}
            <div className="h-2"></div> {/* Small spacer */}
            <p className="font-mono text-xs">{t('footer_tel')} +31 6 87797600</p>
            <div className="h-2"></div> {/* Small spacer */}
            <p className="font-mono text-xs">{t('footer_email')} INFO@ALZIJDIGI.NL</p>
          </div>
          
          {/* Social column */}
          <div className="flex flex-col items-start">
            <SectionHeader titleKey="footer_social" />
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="font-mono text-xs hover:text-emerald-800 transition-colors">{t('footer_instagram')}</a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="font-mono text-xs hover:text-emerald-800 transition-colors">{t('footer_linkedin')}</a>
            <a href="https://wa.me/31687797600" target="_blank" rel="noopener noreferrer" className="font-mono text-xs hover:text-emerald-800 transition-colors">{t('footer_whatsapp')}</a>
            <a href="https://behance.net" target="_blank" rel="noopener noreferrer" className="font-mono text-xs hover:text-emerald-800 transition-colors">{t('footer_behance')}</a>
          </div>
          
          {/* Services column */}
          <div className="flex flex-col items-start">
            <SectionHeader titleKey="footer_services" />
            <FooterLink textKey="service_web_development" to="/services/webontwikkeling" />
            <FooterLink textKey="service_software_app" to="/services/software-app" />
            <FooterLink textKey="service_design_branding" to="/services/design-branding" />
            <FooterLink textKey="service_marketing" to="/services/marketing" />
            <FooterLink textKey="consulting_strategy" to="/services/consulting-strategie" />
          </div>

          
          {/* Pages column */}
          <div className="flex flex-col items-start">
            <SectionHeader titleKey="footer_pages" />
            <FooterLink textKey="home" to="/" />
            <FooterLink textKey="about" to="/over-ons" />
            <FooterLink textKey="footer_cases" to="/cases" />
            <FooterLink textKey="contact" to="/contact" />
            <FooterLink textKey="services" to="/services" />
          </div>
          
          {/* Links column */}
          <div className="flex flex-col items-start">
            <SectionHeader titleKey="footer_links" />
            <FooterLink textKey="footer_link_custom_web" to="/services/maatwerk-web" />
            <FooterLink textKey="footer_link_mobile_app" to="/services/mobiele-app" />
            <FooterLink textKey="footer_link_web_apps" to="/services/web-apps" />
            <FooterLink textKey="footer_link_custom_software" to="/services/maatwerk-software" />
            <FooterLink textKey="footer_link_seo" to="/services/seo" />
            <FooterLink textKey="footer_link_digital_marketing" to="/services/digitale-marketing" />
            <FooterLink textKey="footer_link_custom_design" to="/services/maatwerk-design" />
            <FooterLink textKey="footer_link_saas" to="/services/saas" />
            <FooterLink textKey="footer_link_pwa" to="/services/pwa" />
            <FooterLink textKey="footer_link_ecommerce" to="/services/ecommerce" />
          </div>
        </div>
        
        {/* Separator line */}
        <div className="w-full h-px bg-gray-200 mb-6"></div>
        
        {/* Copyright and privacy row */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center font-mono text-xs">
          <div>
            <p>{t('footer_copyright', { year: currentYear })}</p>
          </div>
          <div>
            <Link to="/privacy" className="hover:text-emerald-800 transition-colors">
              {t('footer_privacy_policy')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}